import React from "react";
import { Button, Menu, Typography, Avatar } from "antd";

import { Link } from "react-router-dom";
import {
  HomeOutlined,
  MoneyCollectOutlined,
  BulbOutlined,
  FundOutlined,
  MenuOutlined,
} from "@ant-design/icons";

import icon from "../images/cryptocurrency.png";

const Navbar = () => {
  return (
    <div style={{ backgroundColor: "#3A3845" }}>
      <div
        style={{ backgroundColor: "#3A3845", display: "flex", padding: "20px" }}
      >
        <Avatar src={icon} size="large" />
        <Typography.Title level={3} className="logo">
          <Link to="/" style={{ textDecoration: "none", color: "white" }}>
            Live Crypto
          </Link>
        </Typography.Title>
        {/* <Button className="menu-control-container"></Button>  */}
      </div>

      <Menu
        theme="dark"
        style={{ backgroundColor: "#3A3845", color: "#3A3845" }}
      >
        <Menu.Item icon={<HomeOutlined />} className="modified-item">
          <Link to="/" style={{ textDecoration: "none" }}>
            Home
          </Link>
        </Menu.Item>

        <Menu.Item icon={<FundOutlined />} style={{ textDecoration: "none" }}>
          <Link to="/CryptoCurrencies" style={{ textDecoration: "none" }}>
            CryptoCurrencies
          </Link>
        </Menu.Item>

        <Menu.Item icon={<BulbOutlined />}>
          <Link to="/News" style={{ textDecoration: "none" }}>
            News
          </Link>
        </Menu.Item>
      </Menu>
    </div>
  );
};

export default Navbar;
